'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationFolderSpecial = function NotificationFolderSpecial(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z' })
  );
};
NotificationFolderSpecial = (0, _pure2.default)(NotificationFolderSpecial);
NotificationFolderSpecial.displayName = 'NotificationFolderSpecial';

exports.default = NotificationFolderSpecial;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/notification/folder-special.js
 ** module id = 1803
 ** module chunks = 0
 **/